import { configApiRef, useApi } from '@backstage/frontend-plugin-api';
import { TypedConfig } from '@ipen-portal/plugin-common';
import { useMemo } from 'react';

export const useTypedConfig = <TConfig>() => {
  const configApi = useApi(configApiRef);
  return useMemo(() => new TypedConfig<TConfig>(configApi), [configApi]);
};
